"use client";
import { ExtendedRecordMap } from "notion-types";
import { NotionRenderer as NotionRendererX } from "react-notion-x";
import { useThemeSwitch } from "../theme-switch";

export default function NotionRenderer({ title, content, accessDate }: { title?: string; content: ExtendedRecordMap; accessDate: Date }) {
  const { theme } = useThemeSwitch();
  return (
    <>
      <span className="hidden">Access date: {accessDate.toLocaleString()}</span>
      <h1 className="text-heading -mt-6 mb-6 tracking-tighter">{title}</h1>
      <NotionRendererX darkMode={theme === "dark"} bodyClassName="!px-0" recordMap={content} />
    </>
  );
}
